import React from 'react'
import Modal, { ModalBody } from '../../_ui/modal'
import AnnouncementText from './announcement-text'
import AnnouncementImage from './announcement-image'
import AnnouncementVideo from './announcement-video'

const AnnouncementModal = ({ data, onClose, onAction }) => {
  if (!data) return null

  const { content_type, title, actions } = data

  const renderContent = () => {
    switch (content_type) {
      case 'text':
        return <AnnouncementText data={data} />
      case 'image':
        return <AnnouncementImage data={data} />
      case 'video':
        return <AnnouncementVideo data={data} />
      default:
        return null
    }
  }

  const handleActionClick = action => {
    const { button_action, button_url } = action

    // Kirim event ke parent
    if (onAction) {
      onAction(action)
    }

    switch (button_action) {
      case 'url':
        if (button_url) {
          window.open(button_url, '_blank', 'noopener,noreferrer')
        }
        break

      case 'dismiss':
        onClose()
        break

      default:
        console.warn('Unknown action:', button_action)
        break
    }
  }

  return (
    <Modal
      key={data.id}
      open={Boolean(data)}
      onClose={onClose}
      disableOutsideClick
      header={{ text: title || 'Announcement' }}
      render={() => (
        <ModalBody>
          {renderContent()}

          {actions?.length > 0 && (
            <div
              style={{
                display: 'flex',
                gap: 8,
                marginTop: 16,
                flexWrap: 'wrap',
                justifyContent: 'center',
              }}
            >
              {actions.map(action => (
                <button
                  key={action.id}
                  onClick={() => handleActionClick(action)}
                  style={{
                    padding: '8px 12px',
                    borderRadius: 8,
                    border: 'none',
                    cursor: 'pointer',
                    background:
                      action.button_style === 'primary' ? '#0070f3' : '#ccc',
                    color: action.button_style === 'primary' ? '#fff' : '#000',
                  }}
                >
                  {action.button_text}
                </button>
              ))}
            </div>
          )}
        </ModalBody>
      )}
    />
  )
}

export default AnnouncementModal
